import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { Box, Button, List, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Trash2 } from "lucide-react";
import type React from "react";
import { SortableItem } from "./SortableItem";

const ColumnBox = styled(Box)(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    minHeight: 400,
    display: "flex",
    flexDirection: "column",
}));

const ColumnTitle = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    fontWeight: 500,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
}));

const ScrollableList = styled(List)({
    flex: 1,
    overflowY: "auto",
});

interface AvailableField {
    key: string;
    label: string;
}

interface SelectedFieldsProps {
    fields: AvailableField[];
    onRemove: (fieldKey: string) => void;
    onClearAll: () => void;
}

const SelectedFields: React.FC<SelectedFieldsProps> = ({ fields, onRemove, onClearAll }) => {
    return (
        <ColumnBox>
            <ColumnTitle variant="h6">
                Selected Fields
                {fields.length > 0 && (
                    <Button
                        size="small"
                        onClick={onClearAll}
                        color="error"
                        startIcon={<Trash2 size={16} />}
                    >
                        Clear All
                    </Button>
                )}
            </ColumnTitle>
            <ScrollableList>
                <SortableContext
                    items={fields.map((f) => f.key)}
                    strategy={verticalListSortingStrategy}
                    id="selected"
                >
                    {fields.map((field) => (
                        <SortableItem
                            key={field.key}
                            id={field.key}
                            onRemove={() => onRemove(field.key)}
                            showRemoveButton={true}
                        >
                            {field.label}
                        </SortableItem>
                    ))}
                </SortableContext>
            </ScrollableList>
        </ColumnBox>
    );
};

export default SelectedFields;
